const clientApprovalStatuses = {
  not_created: { id: 'not_created', name: 'Not Created' },
  pending_approval: { id: 'pending_approval', name: 'Pending Approval' },
  approved: { id: 'approved', name: 'Approved' },
  rejected: { id: 'rejected', name: 'Rejected' },
};

export default clientApprovalStatuses;
